var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enter-order-container"},[_c('button',{staticClass:"filled yellow",attrs:{"disabled":_vm.disableOrderBtn || _vm.disabled},on:{"click":_vm.enterOrderProcess}},[_vm._t("btn")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }